import script from "./JobConfigsCadastro.vue?vue&type=script&setup=true&lang=js"
export * from "./JobConfigsCadastro.vue?vue&type=script&setup=true&lang=js"

import "./JobConfigsCadastro.vue?vue&type=style&index=0&id=16772950&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-16772950"]])

export default __exports__